import React, { useEffect } from 'react';
import { func, node, oneOfType } from 'prop-types';
import { Outlet, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { Helmet } from 'react-helmet';
import ReactGA from 'react-ga';

import { newrelic as LoggerInit } from '@ajaibid/utils';

import { onDoRequestMarketIndex } from 'Redux/stock';
import { useLoginPin } from '@hooks/auth';
import useTracker from '@hooks/useTracker';
import { usePinData } from '@services/users/pin/index';

import configService from '@/services/config';
import PATH_LIST from './constants';

const Layout = ({ children }) => {
  configService.commonConfig.useCommonConfig();
  const { pinData } = usePinData();
  const location = useLocation();
  const dispatch = useDispatch();
  const { pathname, hash } = location || {};
  const indexHash = hash.indexOf('/home/');
  const path = indexHash === 0 && pathname === '/' ? hash.slice(1) : pathname;
  const { isUserNotOnThePinScreen } = useLoginPin();

  // TODO:
  // still buggy if user click other stock detail, every second click variable selected
  // return undefined although the filter condition is return true
  const selectedPath = PATH_LIST.filter(
    (p) => p.regexPathname.test(path) || p.path.indexOf(path) === 0
  );
  const selected = selectedPath[0];
  const code = path.split('/')[selected?.codeIndex] || '';
  const title =
    selected && path !== '/' ? `${selected.title} ${code} | Ajaib.co.id` : 'Ajaib.co.id';
  const userId = pinData?.user_id;

  const { setUserId } = useTracker();

  useEffect(() => {
    if (userId) {
      setUserId(userId);
    }
  }, [userId]);

  useEffect(() => {
    if (isUserNotOnThePinScreen) {
      dispatch(onDoRequestMarketIndex('COMPOSITE'));
    }
  }, [pinData]);

  useEffect(() => {
    // to hit pageview everytime there's a router change
    ReactGA.pageview(pathname + hash);
  }, [location]);

  useEffect(() => {
    LoggerInit({ enabled: false });
  }, []);

  return (
    <>
      <Helmet>
        <title>{title}</title>
        <script type="text/javascript">
          {`window.version = "${process.env.WEB_VERSION || ''}";`}
        </script>
      </Helmet>
      <div style={{ height: '100%' }}>{children || <Outlet />}</div>
    </>
  );
};

Layout.propTypes = {
  children: oneOfType([node, func]),
};
Layout.defaultProps = {
  children: null,
};

export default Layout;
